export const COLUMNS = [
  {
    Id: 'Id',
    accessor: '_id',
  },
  {
    Header: 'Title',
    accessor: 'title',
  },
  // {
  //   Header: 'Status',
  //   accessor: 'status',
  // },
  {
    Header: 'Edit/Delete',
    accessor: '',
  },
];
